import { Skeleton } from '@/components/ui/skeleton';

export function ReportKpiSkeleton() {
  return (
    <div className="report-kpi">
      <div className="report-kpi__header">
        <Skeleton className="h-9 w-12" />
        <Skeleton className="h-4 grow" />
      </div>
      <div className="report-kpi__body">
        <Skeleton className="h-12" />
      </div>
    </div>
  );
}
